module.exports = '<svg width="43" height="32" viewBox="0 0 43 32"><path d="M26.647 32H10.659C4.783 32 0 27.206 0 21.328s4.783-10.667 10.659-10.667c.304 0 .608.011.906.037C13.755 4.359 19.714-.001 26.647-.001c8.817 0 15.988 7.184 15.988 15.999 0 8.817-7.171 16.001-15.988 16.001z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cloud-2.js
// module id = 1073
// module chunks = 14